module.exports = __webpack_public_path__ + "static/media/boisson.ec344126.png";